export default __webpack_public_path__ + "static/media/milestone 1800.99aef025.svg";